export enum FieldTabArrayActionTypes {
  SET_ACTIVE_TAB,
  SET_ACTIVE_TAB_CONTENT,
  SET_DATA,
  SET_PREVIOUS_DATA,
  SET_LAST_ADDED_DATA
}
